import { useForm } from "@tanstack/react-form";
import "../styles/components/business-search-form.css";

export const DISTANCE_OPTIONS = [
  { label: "Any distance", value: "99999" },
  { label: "5 km", value: "5" },
  { label: "10 km", value: "10" },
  { label: "25 km", value: "25" },
  { label: "50 km", value: "50" },
  { label: "100 km", value: "100" },
];

export interface BusinessSearchValues {
  search: string;
  address: string;
  distance: string;
}

interface BusinessSearchFormProps {
  defaultValues?: BusinessSearchValues;
  onSearch?: (values: BusinessSearchValues) => void;
}

export default function BusinessSearchForm({ defaultValues, onSearch }: BusinessSearchFormProps) {
  const form = useForm({
    defaultValues: defaultValues ?? {
      search: "",
      address: "",
      distance: "99999",
    },
    onSubmit: async ({ value }) => {
      onSearch?.({
        search: value.search.trim(),
        address: value.address.trim(),
        distance: value.distance,
      });
    },
  });

  return (
    <form
      className="search-form"
      onSubmit={(e) => {
        e.preventDefault();
        form.handleSubmit();
      }}
    >
      <form.Field name="search">
        {(field) => (
          <input
            id="search-input"
            className="search-form__input"
            type="text"
            placeholder="Business or keyword…"
            value={field.state.value}
            onChange={(e) => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
          />
        )}
      </form.Field>

      <div className="search-form__divider" />

      <form.Field name="address">
        {(field) => (
          <input
            id="address-input"
            className="search-form__input"
            type="text"
            placeholder="Address or suburb…"
            value={field.state.value}
            onChange={(e) => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
          />
        )}
      </form.Field>

      <div className="search-form__divider" />

      <form.Field name="distance">
        {(field) => (
          <select
            id="distance-select"
            className="search-form__distance-select"
            value={field.state.value}
            onChange={(e) => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
          >
            {DISTANCE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}
      </form.Field>

      <button type="submit" className="search-form__submit-button">
        Search
      </button>
    </form>
  );
}
